import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import styles from "./VideoSection.module.css";

const VideoSec = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth(); // 0..11
  const enrollmentYear = currentMonth >= 6 ? currentYear + 1 : currentYear;

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Dispara a conversão e, via callback (ou timeout de segurança), abre o WhatsApp
  const trackConversionAndOpen = (link) => {
    const openWhats = () => {
      window.open(link, "_blank", "noopener,noreferrer");
    };

    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      let called = false;
      const callback = () => {
        if (called) return;
        called = true;
        openWhats();
      };

      // segurança: abre mesmo se o callback não retornar rápido
      const safety = setTimeout(callback, 1200);

      window.gtag("event", "conversion", {
        send_to: "AW-463883905/xgHfCImZwrwbEIGdmd0B",
        event_label: "Agendar visita - VideoSec",
        // Se quiser atribuir valor:
        // value: 0,
        // currency: "BRL",
        event_callback: () => {
          clearTimeout(safety);
          callback();
        },
      });
    } else {
      // Fallback se gtag ainda não carregou
      openWhats();
    }
  };

  const handleScheduleClick = () => {
    trackConversionAndOpen(
      "https://api.whatsapp.com/send/?phone=5585988068633&text=Ol%C3%A1%2C+encontrei+o+site+do+Col%C3%A9gio+Alternativo+Cola%C3%A7o+e+gostaria+de+agendar+uma+visita.+Poderiam+me+ajudar%3F&type=phone_number&app_absent=0"
    );
  };

  return (
    <div className={styles.videoContainer}>
      <div className={styles.videoWrapper} data-aos="fade-up">
        <iframe
          className={styles.videoIframe}
          src="https://www.youtube-nocookie.com/embed/4YydQmmNJEU?rel=0&modestbranding=1&playsinline=1"
          title="MATRÍCULAS 2027 - Colégio Alternativo Colaço"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>

      <div className={styles.textWrapper}>
        <p className={styles.enrollmentYear} data-aos="fade-right">
          MATRÍCULAS 2027
        </p>

        <h2 className={styles.title} data-aos="fade-right" data-aos-delay="200">
          Venha fazer parte do Colégio Alternativo Colaço!
        </h2>

        <p
          className={styles.subtitle}
          data-aos="fade-right"
          data-aos-delay="400"
        >
          AGENDE AGORA!
        </p>

        <p
          className={styles.description}
          data-aos="fade-right"
          data-aos-delay="600"
        >
          Estamos preparados para oferecer uma educação diferenciada, com
          tecnologia e inovação, valorizando o crescimento integral dos nossos
          alunos em um ambiente acolhedor e estimulante.
        </p>

        <p
          className={styles.description}
          data-aos="fade-right"
          data-aos-delay="800"
        >
          Faça parte de um futuro brilhante conosco!
        </p>

        <button
          className={styles.scheduleButton}
          onClick={handleScheduleClick}
          data-aos="fade-up"
          data-aos-delay="1000"
          type="button"
        >
          📅 AGENDAR
        </button>
      </div>
    </div>
  );
};

export default VideoSec;
